import { userDataRequest } from '../../lib/userDataRequest';

export const getNewPhotoId = (title) => {
  const body = { title: title };
  return userDataRequest('post', '/photos', {}, false, body);
};

export const uploadPhoto = (file, featureId, photoId) => {
  let formData = new FormData();
  formData.append('photos', file);

  return userDataRequest(
    'post',
    `/photos/upload?title=${file.name}&photoid=${photoId}&featureid=${featureId}`,
    {
      headers: {
        'content-type': 'multipart/form-data'
      }
    },
    false,
    formData
  );
};

export const getPhoto = (photoId) => {
  return userDataRequest('get', `/photos/${photoId}`);
};

export const deletePhoto = (photoId) => {
  return userDataRequest('delete', `/photos/${photoId}`);
};
